import React from 'react';

import ic_close from "assets/images/ic_close.svg";

import { func_validation } from 'functions';

import 'assets/scss/components/layout/dashboardLayout.scss';

export function DashboardLayout(props) {
    const { className, 
        headerTitle, breadcrumb, 
        isHeaderBorderBottomVisible,
        isHeaderCloseIconVisible, pageHeaderCloseIcon,
        headerDetailTitleClassName, headerDetailTitle,
        headerDetailBodyClassName, headerDetailBody,
        bodyClassName, middleSection, body } = props;

    let headerTitle_formatted = func_validation.isStringTrimNotEmpty(headerTitle)? headerTitle:"";
    let breadcrumb_formatted = func_validation.isNotNullUndefined(breadcrumb)? breadcrumb:"";
    let headerDetailBody_formatted = func_validation.isNotNullUndefined(headerDetailBody)? headerDetailBody: "";
    let headerDetailTitle_formatted = func_validation.isNotNullUndefined(headerDetailTitle)? headerDetailTitle: "";
    let isHeaderDetailsVisible = func_validation.isStringTrimNotEmpty(headerDetailTitle) ||
        func_validation.isNotNullUndefined(headerDetailBody);

    let body_formatted = func_validation.isNotNullUndefined(body)? body:"";

    return (
        <div className={"component-dashboardLayout d-flex flex-column h-100 " + 
                (className? className + " ":"")}>
            <div className={"component-dashboardLayout-header " +
                    (isHeaderBorderBottomVisible? "component-dashboardLayout-header_borderBottom ":"")}>
                {/* Title */}
                <div className="component-dashboardLayout-headerTitle pageHeaderTitle">
                    <span>{headerTitle_formatted}</span>
                    <span className={"component-dashboardLayout-headerTitle-breadcrumbs"}>{breadcrumb_formatted}</span>

                    {/* Close Icon */}
                    {isHeaderCloseIconVisible? (
                        <img
                            className={"component-dashboardLayout-headerTitle-closeIcon " +
                                (pageHeaderCloseIcon? pageHeaderCloseIcon + " ":"")}
                            src={ic_close}
                            alt={"Close icon"}

                            onClick={() => { 
                                if (func_validation.isFunction(props.updateParentState_visiblity)) {                                    
                                    props.updateParentState_visiblity(false);

                                    if (func_validation.isFunction(props.onClose)) {
                                        props.onClose();
                                    }
                                } 
                            }}
                        />
                    ):""}
                </div>

                {/* Detail */}
                {isHeaderDetailsVisible? (
                    <div className="component-dashboardLayout-headerDetail">
                        {/* Title */}
                        <div className={"component-dashboardLayout-headerDetail-title " +
                                        (headerDetailTitleClassName? headerDetailTitleClassName + " ":"")}>
                            {headerDetailTitle_formatted}
                        </div>

                        {/* Body */}
                        <div className={"component-dashboardLayout-headerDetail-body " +
                                        (headerDetailBodyClassName? headerDetailBodyClassName + " ":"")} >
                            {headerDetailBody_formatted}
                        </div>
                    </div>
                ):""}

            </div>

            {/* Middle Section */}
            {middleSection}

            <div className={"component-dashboardLayout-body flex-fill " +
                            (bodyClassName? bodyClassName + " ":"")}>
                {body_formatted}
            </div>
        </div>
    );
}